var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"},[_c('dt',{staticClass:"text-sm leading-5 font-medium text-gray-500"},[_vm._t("leftCol")],2),_vm._v(" "),_c('dd',{staticClass:"mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"},[_vm._t("rightCol")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }